var v = Object.defineProperty;
var o = (n, t) => v(n, "name", { value: t, configurable: !0 });
import { r as c, s as b, A as a, t as w, u as C, v as l, w as u, C as d, c as M, b as I, L as g, G as f, a as m, B as s, d as i, O as h, D as $, M as p } from "./repo-error-BmWg1BdZ.js";
const k = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("customers/lookup", {
      params: {
        email: t.email
      }
    });
  } catch (e) {
    if (c(e))
      return;
    throw b(e) ? new a("emailLookup", e, "tooManyRequests") : w(e) ? new a("emailLookup", e, "validation", {
      email: e.meta?.email?.[0]
    }) : new a("emailLookup", e);
  }
}, "emailLookup"), R = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.post("auth/exchange-sso-token", {
      body: {
        ssoToken: t.token
      }
    });
  } catch (e) {
    throw C(e) && e.status === 422 ? new a("exchangeSsoToken", e, "validation") : new a("exchangeSsoToken", e);
  }
}, "exchangeSsoToken"), x = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.post("auth/inject-jwt", {
      body: {
        email: t.email
      },
      headers: {
        Authorization: `Bearer ${t.jwt}`
      }
    });
  } catch (e) {
    throw w(e) ? new a("injectJWT", e, "validation", {
      email: e.meta?.email?.[0]
    }) : new a("injectJWT", e);
  }
}, "injectJWT"), O = /* @__PURE__ */ o(async (n, t) => {
  try {
    let e;
    t.key === "email" ? e = {
      businessId: t.businessId,
      email: t.email,
      messagingChannel: t.messagingChannel
    } : e = {
      businessId: t.businessId,
      phoneNumber: t.phoneNumber,
      messagingChannel: t.messagingChannel
    }, await n.post("auth/request-otp", {
      body: e
    });
  } catch (e) {
    throw b(e) ? new a("requestOtp", e, "tooManyRequests") : w(e) ? new a("requestOtp", e, "validation", {
      businessId: e.meta?.businessId?.[0],
      email: e.meta?.email?.[0],
      messagingChannel: e.meta?.messagingChannel?.[0],
      phoneNumber: e.meta?.phoneNumber?.[0]
    }) : new a("requestOtp", e);
  }
}, "requestOtp"), P = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.post("auth/set-guest", {
      body: {
        name: t.name,
        email: t.email,
        phoneNumber: t.phoneNumber,
        countryCode: t.countryCode,
        address: t.address
      }
    });
  } catch (e) {
    throw w(e) ? new a("setGuest", e, "validation", {
      name: e.meta?.name?.[0],
      email: e.meta?.email?.[0],
      phoneNumber: e.meta?.phoneNumber?.[0],
      countryCode: e.meta?.countryCode?.[0],
      address: e.meta?.address?.[0]
    }) : new a("setGuest", e);
  }
}, "setGuest"), S = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.post("auth/sign-in", {
      body: {
        email: t.email,
        verificationCode: t.verificationCode
      }
    });
  } catch (e) {
    throw b(e) ? new a("signIn", e, "tooManyRequests") : w(e) ? new a("signIn", e, "validation", {
      email: e.meta?.email?.[0],
      verificationCode: e.meta?.verificationCode?.[0]
    }) : C(e) && e.status === 422 ? new a("signIn", e, "validation") : new a("signIn", e);
  }
}, "signIn"), B = /* @__PURE__ */ o(async (n) => {
  try {
    await n.delete("auth/sign-out");
  } catch (t) {
    throw new a("signOut", t);
  }
}, "signOut"), j = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.post("auth/sign-up", {
      body: {
        businessId: t.businessId,
        name: t.name,
        email: t.email,
        verificationCode: t.verificationCode,
        countryCode: t.countryCode,
        phoneNumber: t.phoneNumber,
        acceptsMarketingCommunications: t.acceptsMarketingCommunications
      }
    });
  } catch (e) {
    throw b(e) ? new a("signUp", e, "tooManyRequests") : l(e) ? new a("signUp", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : w(e) ? new a("signUp", e, "validation", {
      businessId: e.meta?.businessId?.[0],
      name: e.meta?.name?.[0],
      email: e.meta?.email?.[0],
      verificationCode: e.meta?.verificationCode?.[0],
      countryCode: e.meta?.countryCode?.[0],
      phoneNumber: e.meta?.phoneNumber?.[0],
      acceptsMarketingCommunications: e.meta?.acceptsMarketingCommunications?.[0]
    }) : new a("signUp", e);
  }
}, "signUp"), We = {
  emailLookup: k,
  signIn: S,
  signUp: j,
  signOut: B,
  requestOtp: O,
  setGuest: P,
  injectJWT: x,
  exchangeSsoToken: R
}, F = /* @__PURE__ */ o(async (n) => {
  try {
    return await n.get("customers/profile");
  } catch (t) {
    throw new d("profile", t);
  }
}, "profile"), A = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.put("customers/profile", {
      body: {
        name: t.name,
        dateOfBirth: t.dateOfBirth,
        countryCode: t.countryCode,
        phoneNumber: t.phoneNumber
      }
    });
  } catch (e) {
    throw new d("updateProfile", e);
  }
}, "updateProfile"), L = /* @__PURE__ */ o(async (n) => {
  try {
    await n.delete("customers");
  } catch (t) {
    if (c(t))
      return;
    throw new d("deleteAccount", t);
  }
}, "deleteAccount"), T = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("customers/addresses", {
      params: {
        businessId: t.businessId,
        salesChannel: t.salesChannel
      }
    });
  } catch (e) {
    throw new d("getAddresses", e);
  }
}, "getAddresses"), N = /* @__PURE__ */ o(async (n, t) => {
  try {
    return {
      addressId: (await n.post("customers/addresses", {
        body: {
          nickname: t.nickname,
          location: t.location,
          coordinate: {
            latitude: t.coordinate.lat,
            longitude: t.coordinate.lng
          },
          city: t.city,
          country: t.country,
          instruction: t.instruction,
          number: t.number,
          zipCode: t.zipCode
        }
      })).addressId
    };
  } catch (e) {
    throw w(e) ? new d("createAddress", e, "validation", {
      nickname: e.meta?.nickname?.[0],
      location: e.meta?.location?.[0],
      lat: e.meta?.lat?.[0],
      lng: e.meta?.lng?.[0],
      city: e.meta?.city?.[0],
      country: e.meta?.country?.[0],
      instruction: e.meta?.instruction?.[0],
      number: e.meta?.number?.[0],
      zipCode: e.meta?.zipCode?.[0]
    }) : new d("createAddress", e);
  }
}, "createAddress"), D = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.put(`customers/addresses/${t.addressId}`, {
      body: {
        nickname: t.nickname,
        location: t.location,
        coordinate: {
          latitude: t.coordinate.lat,
          longitude: t.coordinate.lng
        },
        city: t.city,
        country: t.country,
        instruction: t.instruction,
        number: t.number,
        zipCode: t.zipCode
      }
    });
  } catch (e) {
    throw w(e) ? new d("updateAddress", e, "validation", {
      nickname: e.meta?.nickname?.[0],
      location: e.meta?.location?.[0],
      lat: e.meta?.lat?.[0],
      lng: e.meta?.lng?.[0],
      city: e.meta?.city?.[0],
      country: e.meta?.country?.[0],
      instruction: e.meta?.instruction?.[0],
      number: e.meta?.number?.[0],
      zipCode: e.meta?.zipCode?.[0]
    }) : new d("updateAddress", e);
  }
}, "updateAddress"), E = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.delete(`customers/addresses/${t.addressId}`);
  } catch (e) {
    throw new d("deleteAddress", e);
  }
}, "deleteAddress"), z = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("customers/preferences", {
      params: t
    });
  } catch (e) {
    throw new d("getCommunicationPreferences", e);
  }
}, "getCommunicationPreferences"), G = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.put("customers/preferences", {
      body: t
    });
  } catch (e) {
    throw new d("updateCommunicationPreferences", e);
  }
}, "updateCommunicationPreferences"), W = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("customers/order-history", {
      params: {
        businessId: t.businessId,
        page: t.page,
        limit: t.perPage
      }
    });
  } catch (e) {
    throw new d("getOrderHistory", e);
  }
}, "getOrderHistory"), Ue = {
  profile: F,
  updateProfile: A,
  deleteAccount: L,
  getAddresses: T,
  createAddress: N,
  updateAddress: D,
  deleteAddress: E,
  getCommunicationPreferences: z,
  updateCommunicationPreferences: G,
  getOrderHistory: W
}, U = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.post("migration/fingerprint", {
      body: {
        hash: t.hash
      }
    });
  } catch (e) {
    throw new M("fingerprint", e);
  }
}, "fingerprint"), He = {
  fingerprint: U
}, H = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `businesses/${t.businessId}/coverages`,
      {
        params: {
          salesChannel: t.salesChannel,
          lat: t.lat,
          lng: t.lng
        }
      }
    );
  } catch (e) {
    throw new I("getCoverageForCoordinates", e);
  }
}, "getCoverageForCoordinates"), J = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `businesses/${t.businessId}/feature-matrix/toggles`,
      {
        params: {
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw new I("getFeatureMatrixToggles", e);
  }
}, "getFeatureMatrixToggles"), Q = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("branding/medias", {
      params: {
        businessId: t.businessId
      }
    });
  } catch (e) {
    throw new I("getMedias", e);
  }
}, "getMedias"), _ = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `businesses/${t.businessId}/outlets`,
      {
        params: {
          search: t.search,
          limit: t.perPage,
          page: t.page,
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw new I("getOutlets", e);
  }
}, "getOutlets"), Je = {
  getFeatureMatrixToggles: J,
  getMedias: Q,
  getCoverageForCoordinates: H,
  getOutlets: _
}, K = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("loyalty/profile", {
      params: {
        businessId: t.businessId,
        outletId: t.outletId,
        salesChannel: t.salesChannel
      }
    });
  } catch (e) {
    throw c(e) ? new g("getCustomerProfile", e, "notFound") : new g("getCustomerProfile", e);
  }
}, "getCustomerProfile"), V = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.post(
      `businesses/${t.businessId}/loyalty-programs/join`
    );
  } catch (e) {
    throw c(e) ? new g("joinProgram", e, "notFound") : new g("joinProgram", e);
  }
}, "joinProgram"), X = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      "loyalty-programs/settings",
      {
        params: {
          businessId: t.businessId,
          outletId: t.outletId,
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw new g("getSettings", e);
  }
}, "getSettings$1"), Y = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("loyalty/configurations", {
      params: {
        businessId: t.businessId,
        channel: t.channel
      }
    });
  } catch (e) {
    throw c(e) ? new g("getSSoProvider", e, "notFound") : new g("getSSoProvider", e);
  }
}, "getSSoProvider"), Qe = {
  getCustomerProfile: K,
  getSettings: X,
  joinProgram: V,
  getSSoProvider: Y
}, Z = /* @__PURE__ */ o(async (n, t) => {
  try {
    await n.post(
      `gift-cards/providers/${t.providerId}/validate`,
      {
        body: {
          outletId: t.outletId,
          salesChannel: t.salesChannel,
          cardNumber: t.cardNumber,
          pin: t.pin,
          amount: t.amount
        }
      }
    );
  } catch (e) {
    throw new f("applyGiftCard", e);
  }
}, "applyGiftCard"), q = /* @__PURE__ */ o(async (n, t) => {
  try {
    return (await n.get(
      "gift-cards/providers",
      {
        params: {
          outletId: t.outletId,
          salesChannel: t.salesChannel
        }
      }
    )).data;
  } catch (e) {
    throw new f("getProviders", e);
  }
}, "getProviders"), _e = {
  applyGiftCard: Z,
  getProviders: q
}, ee = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("bootstrap/start-oat", {
      params: {
        outletSlug: t.outletSlug,
        spotId: t.spotId
      },
      headers: t.jwt ? {
        Authorization: `Bearer ${t.jwt}`
      } : void 0
    });
  } catch (e) {
    if (c(e)) {
      let r = "";
      try {
        const y = JSON.parse(e.context.response.body)?.message;
        r = typeof y == "string" ? y : "";
      } catch {
      }
      if (r === "Outlet not found.")
        throw e.message = `404 ${r}`, new m("startOat", e, "notFound", {
          resource: "outlet"
        });
      if (r === "Business not found.")
        throw e.message = `404 ${r}`, new m("startOat", e, "notFound", {
          resource: "business"
        });
      if (r === "Spot not found.")
        throw e.message = `404 ${r}`, new m("startOat", e, "notFound", {
          resource: "spot"
        });
    }
    throw new m("startOat", e);
  }
}, "startOat"), te = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("bootstrap/start-wo", {
      params: t
    });
  } catch (e) {
    throw c(e) ? new m("startWo", e, "notFound") : new m("startWo", e);
  }
}, "startWo"), Ke = {
  startOat: ee,
  startWo: te
}, ne = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.post(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/items`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel,
          item: t.item
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("addItem", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("addItem", e);
  }
}, "addItem"), oe = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.post(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/automatic-discount`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("applyAutomaticDiscount", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("applyAutomaticDiscount", e);
  }
}, "applyAutomaticDiscount"), se = /* @__PURE__ */ o(async (n, t) => {
  try {
    const { businessId: e, outletId: r, ...y } = t;
    return await n.post(
      `businesses/${e}/outlets/${r}/baskets/checkout`,
      {
        body: y
      }
    );
  } catch (e) {
    throw l(e) ? new s("checkout", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : w(e) ? new s("checkout", e, "validation", {
      scheduledTo: e.meta?.scheduled_to?.[0]
    }) : new s("checkout", e);
  }
}, "checkout"), ae = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/discounts`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel,
          discountCode: t.discountCode
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("applyDiscount", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("applyDiscount", e);
  }
}, "applyDiscount"), re = /* @__PURE__ */ o(async (n, t) => {
  try {
    const { salesChannel: e, orderingMode: r } = t;
    await n.delete(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets`,
      {
        params: {
          salesChannel: e,
          orderingMode: r
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("destroy", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("destroy", e);
  }
}, "destroy"), ie = /* @__PURE__ */ o(async (n, t) => {
  try {
    const { salesChannel: e, orderingMode: r, currency: y } = t;
    return await n.get(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets`,
      {
        params: {
          salesChannel: e,
          orderingMode: r,
          currency: y
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("getBasket", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("getBasket", e);
  }
}, "getBasket"), ce = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/items`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel,
          lineItemId: t.lineItemId,
          quantity: t.quantity
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("updateItemQuantity", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("updateItemQuantity", e);
  }
}, "updateItemQuantity"), de = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/discounts`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("removeDiscount", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("removeDiscount", e);
  }
}, "removeDiscount"), le = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.post(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/loyalty-programs/${t.loyaltyProgramId}`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("applyLoyaltyProgram", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("applyLoyaltyProgram", e);
  }
}, "applyLoyaltyProgram"), ue = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.delete(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/loyalty-programs/${t.loyaltyProgramId}`,
      {
        params: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("removeLoyaltyProgram", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("removeLoyaltyProgram", e);
  }
}, "removeLoyaltyProgram"), he = /* @__PURE__ */ o(async (n, t) => {
  try {
    const { salesChannel: e, orderingMode: r } = t;
    return await n.get(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/loyalty-programs`,
      {
        params: {
          salesChannel: e,
          orderingMode: r
        }
      }
    );
  } catch (e) {
    throw l(e) ? new s("getLoyaltyPrograms", e, "businessRule", {
      violation: e.code,
      context: u(
        e.context.response.body,
        "object"
      )?.error?.context
    }) : new s("getLoyaltyPrograms", e);
  }
}, "getLoyaltyPrograms"), we = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/notes`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel,
          notes: t.notes
        }
      }
    );
  } catch (e) {
    throw new s("setNote", e);
  }
}, "setNote"), ge = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/delivery-location`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel,
          deliveryLocation: t.deliveryLocation
        }
      }
    );
  } catch (e) {
    throw new s("setDeliveryLocation", e);
  }
}, "setDeliveryLocation"), ye = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/scheduled-time`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel,
          ...t.scheduledAt ? { scheduledAt: t.scheduledAt } : {}
        }
      }
    );
  } catch (e) {
    throw new s("setScheduledTime", e);
  }
}, "setScheduledTime"), me = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch("baskets/gift-cards", {
      body: {
        businessId: t.businessId,
        outletId: t.outletId,
        orderingMode: t.orderingMode,
        salesChannel: t.salesChannel,
        ...t.giftCard ? { giftCard: t.giftCard } : {}
      }
    });
  } catch (e) {
    throw new s("setGiftCard", e);
  }
}, "setGiftCard"), pe = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/loyalty-wallet-cash`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel,
          ...t.amount ? { amount: t.amount } : {}
        }
      }
    );
  } catch (e) {
    throw new s("setLoyaltyWalletCash", e);
  }
}, "setLoyaltyWalletCash"), be = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(
      `businesses/${t.businessId}/outlets/${t.outletId}/baskets/meta`,
      {
        body: {
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel,
          meta: t.meta
        }
      }
    );
  } catch (e) {
    throw new s("setMeta", e);
  }
}, "setMeta"), Ve = {
  getBasket: ie,
  addItem: ne,
  updateItemQuantity: ce,
  applyAutomaticDiscount: oe,
  checkout: se,
  applyDiscount: ae,
  removeDiscount: de,
  getLoyaltyPrograms: he,
  applyLoyaltyProgram: le,
  removeLoyaltyProgram: ue,
  destroy: re,
  setNote: we,
  setDeliveryLocation: ge,
  setScheduledTime: ye,
  setGiftCard: me,
  setLoyaltyWalletCash: pe,
  setMeta: be
}, Ie = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `businesses/${t.businessId}/pickup-outlets`,
      {
        params: {
          salesChannel: t.salesChannel,
          city: t.city,
          lat: t.lat,
          lng: t.lng,
          name: t.name
        }
      }
    );
  } catch (e) {
    throw new i("getPickupOutlets", e);
  }
}, "getPickupOutlets"), Ce = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `businesses/${t.businessId}/pickup-cities`,
      {
        params: {
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw new i("getPickupCities", e);
  }
}, "getPickupCities"), fe = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `outlets/${t.outletId}/settings`,
      {
        params: {
          salesChannel: t.salesChannel,
          orderingMode: t.orderingMode
        }
      }
    );
  } catch (e) {
    throw new i("getSettings", e);
  }
}, "getSettings"), ve = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `outlets/${t.outletId}/spots/${t.spotId}`
    );
  } catch (e) {
    throw c(e) ? new i("getSpot", e, "notFound") : new i("getSpot", e);
  }
}, "getSpot"), Me = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `outlets/${t.outletId}/spots`,
      {
        params: {
          page: t.page,
          perPage: t.perPage
        }
      }
    );
  } catch (e) {
    throw new i("getSpots", e);
  }
}, "getSpots"), $e = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(`outlets/${t.outletId}`, {
      params: {
        salesChannel: t.salesChannel,
        orderingMode: t.orderingMode
      }
    });
  } catch (e) {
    throw c(e) ? new i("getOutletById", e, "notFound") : new i("getOutletById", e);
  }
}, "getOutletById"), ke = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("outlets", {
      params: {
        businessId: t.businessId,
        slug: t.outletSlug,
        salesChannel: t.salesChannel,
        orderingMode: t.orderingMode
      }
    });
  } catch (e) {
    throw c(e) ? new i("getOutletBySlug", e, "notFound") : new i("getOutletBySlug", e);
  }
}, "getOutletBySlug"), Re = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `outlets/${t.outletId}/menus`,
      {
        params: {
          businessId: t.businessId,
          orderingMode: t.orderingMode,
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw new i("getMenus", e);
  }
}, "getMenus"), xe = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `outlets/${t.outletId}/menu`,
      {
        params: {
          slug: t.menuSlug,
          salesChannel: t.salesChannel,
          ...t.availableFrom ? { availableFrom: t.availableFrom } : {},
          ...t.availableTo ? { availableTo: t.availableTo } : {}
        }
      }
    );
  } catch (e) {
    throw c(e) ? new i("getMenu", e, "notFound") : new i("getMenu", e);
  }
}, "getMenu"), Oe = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `outlets/${t.outletId}/ordering-modes/${t.orderingMode}/schedulable-time-slots`
    );
  } catch (e) {
    throw new i("getTimeSlots", e);
  }
}, "getTimeSlots"), Pe = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `outlets/${t.outletId}/payment-methods`,
      {
        params: {
          orderingService: t.orderingMode,
          salesChannel: t.salesChannel
        }
      }
    );
  } catch (e) {
    throw new i("getPaymentMethods", e);
  }
}, "getPaymentMethods"), Xe = {
  getPickupOutlets: Ie,
  getPickupCities: Ce,
  getSettings: fe,
  getSpot: ve,
  getSpots: Me,
  getOutletById: $e,
  getOutletBySlug: ke,
  getMenus: Re,
  getMenu: xe,
  getTimeSlots: Oe,
  getPaymentMethods: Pe
}, Se = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(`orders/${t.orderId}`);
  } catch (e) {
    throw e instanceof Error && e.message.includes("404") ? new h("getOrderById", e, "notFound") : new h("getOrderById", e);
  }
}, "getOrderById"), Be = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("orders/ongoing", {
      params: {
        businessId: t.businessId
      }
    });
  } catch (e) {
    throw new h("getOngoingOrders", e);
  }
}, "getOngoingOrders"), je = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(`orders/${t.orderId}/status`);
  } catch (e) {
    throw e instanceof Error && e.message.includes("404") ? new h("getStatus", e, "notFound") : new h("getStatus", e);
  }
}, "getStatus"), Fe = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(`orders/tracking/${t.trackingId}`);
  } catch (e) {
    throw e instanceof Error && e.message.includes("404") ? new h("getOrderByTrackingId", e, "notFound") : new h("getOrderByTrackingId", e);
  }
}, "getOrderByTrackingId"), Ae = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("orders/review-pending", {
      params: {
        businessId: t.businessId,
        orderId: t.orderId
      }
    });
  } catch (e) {
    throw new h("orderHasPendingReview", e);
  }
}, "orderHasPendingReview"), Le = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.patch(`orders/${t.orderId}/review`);
  } catch (e) {
    throw new h("skipReview", e);
  }
}, "skipReview"), Te = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.post(
      `orders/${t.orderId}/review`,
      {
        body: {
          rating: t.rating,
          comment: t.comment,
          reason: t.reason
        }
      }
    );
  } catch (e) {
    throw new h("addReview", e);
  }
}, "addReview"), Ye = {
  getById: Se,
  getByTrackingId: Fe,
  getOngoingOrders: Be,
  getStatus: je,
  pendingReview: Ae,
  skipReview: Le,
  addReview: Te
}, Ne = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(
      `businesses/${t.businessId}/outlets/${t.outletId}/discounts`,
      {
        params: {
          orderingMode: t.orderingMode
        }
      }
    );
  } catch (e) {
    throw new $("getDiscounts", e);
  }
}, "getDiscounts"), Ze = {
  getDiscounts: Ne
}, De = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get(`items/${t.itemId}`, {
      params: {
        outletId: t.outletId
      }
    });
  } catch (e) {
    throw c(e) ? new p("getItem", e, "notFound") : new p("getItem", e);
  }
}, "getItem"), Ee = /* @__PURE__ */ o(async (n, t) => {
  try {
    return await n.get("items", {
      params: {
        plu: t.plu,
        outletId: t.outletId,
        menuIds: t.menuIds
      }
    });
  } catch (e) {
    throw c(e) ? new p("getItems", e, "notFound") : new p("getItems", e);
  }
}, "getItems"), qe = {
  getItem: De,
  getItems: Ee
};
export {
  We as a,
  Ve as b,
  Ke as c,
  Je as d,
  Ue as e,
  Ze as f,
  _e as g,
  He as h,
  Xe as i,
  Qe as l,
  qe as m,
  Ye as o
};
